import { SortDirection } from "config/constants"

export interface IShippingOrderAssetsSort {
    sortBy: ShippingOrderAssetsSortBy
    sortDirection: SortDirection
}

export enum ShippingOrderAssetsSortBy {
    articleDescription = "articleDescription",
    lmid = "lmid",
    stateOfStorage = "stateOfStorage",
    fromLocation = "fromLocation",
    toLocation = "toLocation",
    startDate = "startDate",
    endDate = "endDate",
}

export interface IShippingResultAssetsSort {
    sortBy: ShippingResultAssetsSortBy
    sortDirection: SortDirection
}

export enum ShippingResultAssetsSortBy {
    plannedArticleDescription = "plannedArticleDescription",
    plannedLmid = "plannedLmid",
    operation = "operation",
    shippedArticleDescription = "shippedArticleDescription",
    shippedLmid = "shippedLmid",
}
